import {
  OPEN_DROPDOWN,
  CHECK_OPTION,
  CLOSE_DROPDOWN,
  CHECK_PILL_CAPTURE,
  CLEAR_FILTERS,
  SHOW_ALL_CLICK,
  SHOW_ALL_CAPTURES,
  SHOW_ALL_POPULAR,
  UNCHECK_OPTION,
} from "./constants";

import { analyticsEvents } from "@helpers/Analytics";

const analyticsDispatcher = (dispatch) => (state) => (action) => {
  const dispatchCreateRoomEvent = (label) => {
    dispatch(analyticsEvents.createRoomEvent.action, label);
  };
  switch (action.type) {
    case CHECK_OPTION:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.checkOption(
          action.payload.filterProp,
          action.payload.key
        )
      );
      break;
    case SHOW_ALL_CLICK:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.showAll(
          action.payload.filterProp,
          action.payload.key
        )
      );
      break;
    case UNCHECK_OPTION:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.uncheckOption(
          action.payload.filterProp,
          action.payload.key
        )
      );
      break;
    case CLEAR_FILTERS:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.clearFilters()
      );
      break;
    case OPEN_DROPDOWN:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.openFilter(action.payload)
      );
      break;
    case CLOSE_DROPDOWN:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.closeFilter(action.payload)
      );
      break;
    case SHOW_ALL_CAPTURES:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.showAll("captures")
      );
      break;
    case SHOW_ALL_POPULAR:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.showAll("popular")
      );
      break;
    case CHECK_PILL_CAPTURE:
      dispatchCreateRoomEvent(
        analyticsEvents.createRoomEvent.labels.checkOption("captures")
      );
      break;

    default:
      break;
  }
};

export default analyticsDispatcher;
